const agentAttorneyIndividsView = (data) => {
    let formData = data && data.getAgentById && data.getAgentById.AgentFormData
    if(formData){  
        let view = {
            name: formData.new_profile_individual_agent_profile_name,
            sections: [
                {
                    name: 'Agent/Attorney (Individual) - Profile',
                    fields: [
                        {
                            number: 1,
                            label: 'Agent or Attorney',
                            value: formData.new_profile_individual_agent_type_id,

                        },
                    ]
                },
                {
                    name: 'Name',
                    fields: [
                        {
                            number: 2,
                            label: 'Last name',
                            value: formData.new_profile_individual_agent_last_name,

                        },
                        {
                            number: 3,
                            label: 'First name',
                            value: formData.new_profile_individual_agent_first_name,

                        },
                        {
                            number: 4,
                            label: 'Middle name',
                            value: formData.new_profile_individual_agent_middle_name,

                        },
                    ]
                },
                {
                    name: 'Address',
                    fields: [
                        {
                            number: 5,
                            label: 'Address 1',
                            value: formData.new_profile_individual_agent_address_1,
                            
                        },
                        {
                            number: 6,
                            label: 'Address 2',
                            value: formData.new_profile_individual_agent_address_2,
                        },
                        {
                            number: 7,
                            label: 'City',
                            value: formData.new_profile_individual_agent_city,
                            
                        },
                        {
                            number: 8,
                            label: 'State',
                            value: formData.new_profile_individual_agent_state_id,
                            
                        },
                        {
                            number: 9,
                            label: 'Postal Code',
                            value: formData.new_profile_individual_agent_zip,
                            
                        },
                        {
                            number: 10,
                            label: 'Country',
                            value: formData.new_profile_individual_agent_country_id,
                            
                        },
                        {
                            number: 11,
                            label: 'Province (if applicable)',
                            value: formData.new_profile_individual_agent_province,
                            
                        },
                    ]
                },
                {
                    name: 'Contact Information',
                    fields: [
                        {
                            number: 12,
                            label: 'Telephone Number',
                            value: formData.new_profile_individual_agent_phone,
                            
                        },
                        {
                            number: 13,
                            label: 'Extension',
                            value: formData.new_profile_individual_agent_phone_ext,
                            
                        },
                        {
                            number: 14,
                            label: 'Email',
                            value: formData.new_profile_individual_agent_email,
                            
                        },
                    ]
                },
                {
                    name: 'Identifiers',
                    fields: [
                        {
                            number: 15,
                            label: 'State Bar Number(s)',
                            value: formData.new_profile_individual_agent_bar_number

                        },
                        {
                            number: 16,
                            label: 'Court State Location',
                            value: formData.new_profile_individual_agent_court_state_id

                        },
                        {
                            number: 17,
                            label: 'Court Name',
                            value: formData.new_profile_individual_agent_court_name

                        },
                        {
                            number: 18,
                            label: 'Job Title',
                            value: formData.new_profile_individual_agent_job_title

                        }
                    ]
                }
            ]
        }
        return view;
    }
}

export default agentAttorneyIndividsView